import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Spin, Divider, Form, message } from 'antd';
import commonS from 'styles/common.module.less';
import s from './s.module.less';

import WeekItem from './components/WeekItem';
import TimeZoneSelect from 'components/form/TimeZoneSelect';

import { TimeFormFieldEnum, TimeFormInterface } from './types';
import { providerAvailabilitySave } from 'api/appointmentSetting';
import { IproviderAvailabilityItem } from 'types/appointmentSetting';
import { getUserId, setTimeZone } from 'utils/localstore';
import useAvailability, { initData } from 'hooks/useAvailability';
import useTimezone from 'hooks/useTimezone';

const TimezoneOperationhours = forwardRef((props, ref) => {
    const [form] = Form.useForm<TimeFormInterface>();
    const [weekList, setWeekList] = useState<IproviderAvailabilityItem[]>([]);
    const [availabilityList, loading, refetch] = useAvailability();
    const [allTimezone, myTimezone, , , refetchTimezone] = useTimezone();
    const uid = getUserId();

    const onUpdate = async (newWeekList?: IproviderAvailabilityItem[]) => {
        try {
            const formValues = await form.validateFields();
            const params = {
                week: newWeekList ?? weekList,
                timezone: formValues[TimeFormFieldEnum.TIME_ZONE],
                providerId: uid,
            };
            const { data } = await providerAvailabilitySave(params, uid!);
            if (data.code === 200) {
                setTimeZone(formValues[TimeFormFieldEnum.TIME_ZONE]);
                refetchTimezone();
            } else {
                message.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useImperativeHandle(ref, () => ({
        onUpdate,
    }));

    const changeTimeList = useCallback((val: IproviderAvailabilityItem) => {
        setWeekList((preWeekList) => {
            const newWeekList = preWeekList.map((item) => (item.weekDay === val.weekDay ? { ...item, hourFromTo: val.hourFromTo } : item));
            onUpdate(newWeekList);
            return newWeekList;
        });
    }, []);

    const sortByWeekDay = (a: IproviderAvailabilityItem, b: IproviderAvailabilityItem) => {
        const day: any = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };
        return day[a.weekDay!] - day[b.weekDay!];
    };

    useEffect(() => {
        if (availabilityList) {
            const { timezone, week, isInit } = availabilityList;
            let defaultTimezone = timezone || myTimezone.value as string || initData.timezone;
            if (isInit) {
                defaultTimezone = myTimezone.value as string || initData.timezone;
            }
            form.setFieldsValue({ [TimeFormFieldEnum.TIME_ZONE]: defaultTimezone });
            if (week && week?.length > 0) {
                week.sort(sortByWeekDay);
                setWeekList(week);
            } else {
                setWeekList(initData.week!);
            }
        }
    }, [availabilityList]);

    return (
        <Spin spinning={loading}>
            <div className={s.wrap}>
                <Form
                    form={form}
                    name="basic"
                    className={commonS.formStyle1}
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label={<div className={s.hourTitle}>Time zone</div>}
                        name={[TimeFormFieldEnum.TIME_ZONE]}
                        validateFirst
                        rules={[
                            { required: true, message: 'Time zone is required' },
                        ]}
                    >
                        <TimeZoneSelect className={s.timezone} onChange={() => onUpdate()} />
                    </Form.Item>
                </Form>

                {
                    weekList && weekList.map((item, index) => {
                        return (
                            <div key={index}>
                                <WeekItem weekItemData={item} changeTimeList={changeTimeList} />
                                <Divider />
                            </div>
                        );
                    })
                }

            </div>
        </Spin>
    );
});

TimezoneOperationhours.displayName = 'TimezoneOperationhours';

export default TimezoneOperationhours;
